import { Component, EventEmitter, Input, OnInit, Output,HostListener, SimpleChanges, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';

@Component({
  selector: 'app-mobile-bottombar',
  templateUrl: './mobile-bottombar.component.html',
  styleUrls: ['./mobile-bottombar.component.scss'],
})
export class MobileBottombarComponent implements OnInit {

  screenWidth: number;

  @ViewChild('addon3') addon3!: MatExpansionPanel;
  @Input() disabledCondition: boolean = false;
  @Input() disabledContactPS: boolean = false;
  @Input() buttonTemplate: any;
  @Input() voucherTemplate: any;
  @Input() discountTemplate: any;
  @Input() isGeneraliQuotation: boolean = false;
  @Input() isRetryPayment: boolean = false;
  @Input() expandVoucher: boolean = false;
  @Output() onReviewButtonClick = new EventEmitter<void>();
  @Output() onSubmit = new EventEmitter();
  @Output() voucherToggle = new EventEmitter<boolean>();
  

  constructor() {
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenWidth = event.target.innerWidth;
  }

  ngAfterViewInit() {
    if (this.expandVoucher) {
      this.addon3.open();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['expandVoucher']) {
      const value = changes['expandVoucher'].currentValue;

      if (value) {
        this.addon3?.open(); 
      } else {
        this.addon3?.close();
      }
    }
  }

  handleReviewBtnClick(): void {
    this.onReviewButtonClick.emit();
  }

  closePanel() {
    this.expandVoucher = false;
    this.voucherToggle.emit(false);
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
  }

  submit() {
    this.onSubmit.emit();
  }
}
